import { getPersonName } from '@fs/zion-sls'

/**
 * Narrows a list of persons to those whose name matches the filter text.
 *
 * This only ever affects what is *displayed*. Checkbox selections are model state, so a person
 * filtered out of view must keep any selection they already had — callers must not derive their
 * selection state from this result.
 *
 * @param {Object} params
 * @param {Array<Object>} params.persons - SLS person elements to filter
 * @param {string} [params.filterValue=''] - Patron-entered filter text; blank returns every person
 * @returns {Array<Object>} The persons whose name contains the filter text, case-insensitively
 */
export const filterPersonsByName = ({ persons, filterValue = '' }) => {
  const normalizedFilter = filterValue.trim().toLocaleLowerCase()
  if (!normalizedFilter) return persons

  return persons.filter((person) => (getPersonName({ person }) || '').toLocaleLowerCase().includes(normalizedFilter))
}

export default filterPersonsByName
